import { ThunkAction } from "@reduxjs/toolkit";

import getRegionComplianceRules from "api/requests/consumerApi/getRegionComplianceRules";
import {
  CartDispensaryActions,
  LOAD_CHECKOUT_DISCLAIMER,
} from "redux/reducers/cartDispensary";
import { RootState } from "redux/reducers/rootReducer";
import { getCartDispensaryData } from "redux/selectors/cartDispensary";

// * Used to pull the compliance rule checkoutDisclaimer field for displaying in checkout.
export const loadCheckoutDisclaimerThunk =
  (): ThunkAction<void, RootState, void, CartDispensaryActions> =>
  async (dispatch, getState) => {
    const cartDispensary = getCartDispensaryData(getState());

    if (!cartDispensary) {
      // * Usually happens when a users bag / cart is empty. Just noop in that case!
      return;
    }

    const complianceRules = await getRegionComplianceRules(
      cartDispensary.state,
      cartDispensary.country
    );
    dispatch({
      checkoutDisclaimer: complianceRules?.rules?.checkoutDisclaimer
        ? String(complianceRules.rules.checkoutDisclaimer)
        : null,
      type: LOAD_CHECKOUT_DISCLAIMER,
    });
  };
